import { Button, TextField } from "@mui/material";
import SelectUpload from "../../Modals/select_upload";
import { useState } from "react";
import EditText from "../../components/editText";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from '@mui/icons-material/Close';
const ServiceProviderLanding = () => {
    const [openModal, setOpenModal] = useState(false);
    const [features, setfeatures] = useState<string>("");

    const handleCloseModal = () => setOpenModal(false);
    const [featuresList, setFeaturesList] = useState([
        { id: Date.now(), title: "", desc: "", img: null }
    ]);
    const addFeature = () => {
        setFeaturesList(prev => [
            ...prev,
            { id: Date.now(), title: "", desc: "", img: null }
        ]);
    };

    const removeFeature = (id: number) => {
        setFeaturesList(prev => prev.filter(item => item.id !== id));
    };

    return (
        <>
            <div className="main_title">
                <h1>Manage Service Provider Landing Page</h1>
            </div>

            {/* Banner Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Banner Section</h2>
                </div>

                <form className="form">
                    <div className="gap_m">

                        {/* Upload Banner Image */}
                        <div className="control_group w_100">
                            <label htmlFor="banner_upload_btn">Upload Banner Image</label>
                            <div className="upload_box">
                                <button type="button" id="banner_upload_btn" className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                    <p>
                                        <img src="/static/images/upload_icon.svg" alt="upload" />
                                        <strong>Click to upload Image or take photo</strong>
                                    </p>
                                </button>
                            </div>
                        </div>

                        {/* Top Slogan */}
                        <div className="control_group w_33">
                            <label htmlFor="top_slogan">Top Slogan</label>
                            <TextField
                                id="top_slogan"
                                placeholder="Enter Top Slogan"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        {/* Page Title */}
                        <div className="control_group w_33">
                            <label htmlFor="page_title">Page Title</label>
                            <TextField
                                id="page_title"
                                placeholder="Enter Page Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        {/* Page Description */}
                        <div className="control_group w_33">
                            <label htmlFor="page_desc">Page Description</label>
                            <TextField
                                id="page_desc"
                                placeholder="Enter Page Description"
                                fullWidth
                                multiline
                                rows={3}
                                hiddenLabel
                            />
                        </div>

                        {/* Button Primary */}
                        <div className="control_group w_33">
                            <label htmlFor="btn_primary">Button Text (Primary)</label>
                            <TextField
                                id="btn_primary"
                                placeholder="Enter Primary Button Text"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        {/* Button Secondary */}
                        <div className="control_group w_33">
                            <label htmlFor="btn_secondary">Button Text (Secondary)</label>
                            <TextField
                                id="btn_secondary"
                                placeholder="Enter Secondary Button Text"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                    </div>
                </form>
            </div>
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Trusted by the Best in UAE</h2>
                </div>

                <div className="form gap_m">
                    <div className="control_group w_100">
                        <label>Select Stats to Display</label>
                        <div className="flex gap_m mt_10" style={{ flexWrap: 'wrap', gap: '16px' }}>
                            {[
                                { id: 'stat_orders_placed', value: '12.4K', label: 'Trusted Vendors' },
                                { id: 'stat_new_reviews', value: '2.4K', label: 'Uptime Guarantee' },
                                { id: 'stat_trending_products', value: '156', label: 'Active Customers' },
                                { id: 'stat_active_vendors', value: '1,240', label: 'Active Vendors' },
                                { id: 'stat_customer_satisfaction', value: '98%', label: 'Customer Satisfaction' },
                                { id: 'stat_on_time_delivery', value: '94%', label: 'On-Time Delivery' },
                                { id: 'stat_avg_delivery', value: '1.8 Days', label: 'Avg Delivery' },
                                { id: 'stat_licensed_sellers', value: '100', label: 'Licensed sellers' },
                            ].map((stat) => (
                                <div key={stat.id} style={{
                                    flex: '1 1 calc(25% - 16px)',
                                    minWidth: '200px',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#ffffff',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    boxSizing: 'border-box'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                        <h3 style={{ margin: 0, fontSize: '26px', fontWeight: 700, color: '#111827', lineHeight: '1.2' }}>{stat.value}</h3>
                                        <input
                                            type="checkbox"
                                            id={stat.id}
                                            name={stat.id}
                                            style={{ width: '20px', height: '20px', cursor: 'pointer', margin: 0, marginTop: '2px', accentColor: '#000' }}
                                        />
                                    </div>
                                    <label htmlFor={stat.id} style={{ margin: 0, fontSize: '15px', color: '#6b7280', fontWeight: 500, cursor: 'pointer', display: 'block', width: '100%' }}>
                                        {stat.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* Platform Features */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Platform Features</h2>
                </div>

                <form className="form">
                    <div className="gap_m">

                        <div className="control_group w_33">
                            <label htmlFor="feature_section_title">Title</label>
                            <TextField
                                id="feature_section_title"
                                placeholder="Enter Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="feature_section_desc">Description</label>
                            <TextField
                                id="feature_section_desc"
                                placeholder="Enter Description"
                                fullWidth
                                multiline
                                rows={3}
                                hiddenLabel
                            />
                        </div>

                        {/* Feature 1 Header */}
                        {featuresList.map((item, index) => (
                            <div key={item.id} className="feature_block">

                                <div className="title_inner w_100 flex space-between">
                                    <h3>Feature {index + 1}</h3>
                                    {featuresList.length > 1 && (
                                        <Button className="btn btn_primary sm" onClick={() => removeFeature(item.id)}>
                                            <CloseIcon /> Remove Feature
                                        </Button>
                                    )}
                                </div>

                                <div className="control_group w_100">
                                    <div className="gap_p">

                                        <div className="control_group w_33">
                                            <label htmlFor={`feature_upload_${item.id}`}>Upload Image</label>
                                            <div className="upload_box">
                                                <button type="button" id={`feature_upload_${item.id}`} className="upload_action" style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                                    <p>
                                                        <img src="/static/images/upload_icon.svg" alt="upload" />
                                                        <strong>Click to upload Image or take photo</strong>
                                                    </p>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="control_group w_33">
                                            <label htmlFor={`feature_title_${item.id}`}>Title</label>
                                            <TextField
                                                id={`feature_title_${item.id}`}
                                                placeholder="Enter Title"
                                                fullWidth
                                                hiddenLabel
                                            />
                                        </div>

                                        <div className="control_group w_33">
                                            <label htmlFor={`feature_desc_${item.id}`}>Description</label>
                                            <TextField
                                                id={`feature_desc_${item.id}`}
                                                placeholder="Enter Description"
                                                fullWidth
                                                hiddenLabel
                                            />
                                        </div>

                                    </div>
                                </div>

                            </div>
                        ))}

                        <div className="form_btn">
                            <Button className="btn btn_primary" onClick={addFeature}>
                                <AddIcon /> Add New Feature
                            </Button>
                        </div>


                    </div>
                </form>
            </div>

            {/* Why Choose Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Why Choose Bouteek</h2>
                </div>

                <form className="form">
                    <div className="gap_m">

                        <div className="control_group w_33">
                            <label htmlFor="why_title">Section Title</label>
                            <TextField
                                id="why_title"
                                placeholder="Enter Section Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="why_desc">Description</label>
                            <TextField
                                id="why_desc"
                                placeholder="Enter Description"
                                fullWidth
                                multiline
                                rows={3}
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="features_editor">Features</label>
                            <div id="features_editor">
                                <EditText content={features} setContent={setfeatures} />
                            </div>
                        </div>

                    </div>
                </form>
            </div>

            {/* CTA Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>CTA</h2>
                </div>

                <form className="form">
                    <div className="gap_m">

                        <div className="control_group w_33">
                            <label htmlFor="cta_title">CTA Title</label>
                            <TextField
                                id="cta_title"
                                placeholder="Enter CTA Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="cta_desc">CTA Description</label>
                            <TextField
                                id="cta_desc"
                                placeholder="Enter CTA Description"
                                fullWidth
                                multiline
                                rows={3}
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="cta_btn">CTA Button</label>
                            <TextField
                                id="cta_btn"
                                placeholder="Enter Button Text"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                    </div>
                </form>
            </div>

            {/* Save Button */}
            <div className="form_btn">
                <Button className="btn btn_primary">Save & Upload</Button>
            </div>

            <SelectUpload
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
}

export default ServiceProviderLanding;
